"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionResponse = exports.UrlQuery = exports.TxnQuery = exports.TxResponse = exports.TxRequest = exports.TxReceipt = exports.TxHistoryQuery = exports.TransactionQueryResponse = exports.TokenSend = exports.TokenDeposit = exports.SyntheticTransactionRequest = exports.StatusResponse = exports.SignerMetadata = exports.Signer = exports.SignaturePage = exports.SignatureBook = exports.ResponseKeyPageIndex = exports.ResponseDataEntrySet = exports.ResponseDataEntry = exports.QueryPagination = exports.QueryOptions = exports.PartitionDescription = exports.NodeDescription = exports.NetworkDescription = exports.MultiResponse = exports.MinorQueryResponse = exports.MinorBlocksQuery = exports.MinorBlock = exports.MetricsResponse = exports.MetricsQuery = exports.MerkleState = exports.MajorQueryResponse = exports.MajorBlocksQuery = exports.KeyPageIndexQuery = exports.KeyPage = exports.GeneralReceipt = exports.GeneralQuery = exports.ExecuteRequest = exports.DirectoryQuery = exports.DescriptionResponse = exports.DataEntrySetQuery = exports.DataEntryQueryResponse = exports.DataEntryQuery = exports.ChainState = exports.ChainQueryResponse = exports.ChainIdQuery = exports.ChainEntry = void 0;
const _1 = require(".");
const txid_1 = require("../address/txid");
const url_1 = require("../address/url");
const buffer_1 = require("../common/buffer");
const encoding_1 = require("../encoding");
const errors2 = __importStar(require("../errors"));
const merkle = __importStar(require("../merkle"));
const messaging = __importStar(require("../messaging"));
const core = __importStar(require("../network"));
const config = __importStar(require("./config"));
const protocol = __importStar(require("./protocol"));
class ChainEntry {
    constructor(args) {
        this.height = args.height == undefined ? undefined : args.height;
        this.entry =
            args.entry == undefined
                ? undefined
                : args.entry instanceof Uint8Array
                    ? args.entry
                    : buffer_1.Buffer.from(args.entry, "hex");
        this.state =
            args.state == undefined
                ? undefined
                : args.state.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
        this.value = args.value == undefined ? undefined : args.value;
    }
    copy() {
        return new ChainEntry(this.asObject());
    }
    asObject() {
        return {
            height: this.height && this.height,
            entry: this.entry && this.entry && buffer_1.Buffer.from(this.entry).toString("hex"),
            state: this.state &&
                this.state?.map((v) => (v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex"))),
            value: this.value && this.value,
        };
    }
}
exports.ChainEntry = ChainEntry;
class ChainIdQuery {
    constructor(args) {
        this.chainId =
            args.chainId == undefined
                ? undefined
                : args.chainId instanceof Uint8Array
                    ? args.chainId
                    : buffer_1.Buffer.from(args.chainId, "hex");
    }
    copy() {
        return new ChainIdQuery(this.asObject());
    }
    asObject() {
        return {
            chainId: this.chainId && this.chainId && buffer_1.Buffer.from(this.chainId).toString("hex"),
        };
    }
}
exports.ChainIdQuery = ChainIdQuery;
class ChainQueryResponse {
    constructor(args) {
        this.type = args.type == undefined ? undefined : args.type;
        this.mainChain =
            args.mainChain == undefined
                ? undefined
                : args.mainChain instanceof MerkleState
                    ? args.mainChain
                    : new MerkleState(args.mainChain);
        this.chains =
            args.chains == undefined
                ? undefined
                : args.chains.map((v) => v == undefined ? undefined : v instanceof ChainState ? v : new ChainState(v));
        this.data = args.data == undefined ? undefined : args.data;
        this.chainId =
            args.chainId == undefined
                ? undefined
                : args.chainId instanceof Uint8Array
                    ? args.chainId
                    : buffer_1.Buffer.from(args.chainId, "hex");
        this.receipt =
            args.receipt == undefined
                ? undefined
                : args.receipt instanceof GeneralReceipt
                    ? args.receipt
                    : new GeneralReceipt(args.receipt);
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new ChainQueryResponse(this.asObject());
    }
    asObject() {
        return {
            type: this.type && this.type,
            mainChain: this.mainChain && this.mainChain.asObject(),
            chains: this.chains && this.chains?.map((v) => (v == undefined ? undefined : v.asObject())),
            data: this.data && this.data,
            chainId: this.chainId && this.chainId && buffer_1.Buffer.from(this.chainId).toString("hex"),
            receipt: this.receipt && this.receipt.asObject(),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
exports.ChainQueryResponse = ChainQueryResponse;
class ChainState {
    constructor(args) {
        this.name = args.name == undefined ? undefined : args.name;
        this.type = args.type == undefined ? undefined : protocol.ChainType.fromObject(args.type);
        this.height = args.height == undefined ? undefined : args.height;
        this.roots =
            args.roots == undefined
                ? undefined
                : args.roots.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
    }
    copy() {
        return new ChainState(this.asObject());
    }
    asObject() {
        return {
            name: this.name && this.name,
            type: this.type && protocol.ChainType.getName(this.type),
            height: this.height && this.height,
            roots: this.roots &&
                this.roots?.map((v) => (v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex"))),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], ChainState.prototype, "name", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], ChainState.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], ChainState.prototype, "height", void 0);
__decorate([
    encoding_1.encodeAs.field(4).repeatable.bytes
], ChainState.prototype, "roots", void 0);
exports.ChainState = ChainState;
class DataEntryQuery {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.entryHash =
            args.entryHash == undefined
                ? undefined
                : args.entryHash instanceof Uint8Array
                    ? args.entryHash
                    : buffer_1.Buffer.from(args.entryHash, "hex");
    }
    copy() {
        return new DataEntryQuery(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            entryHash: this.entryHash && this.entryHash && buffer_1.Buffer.from(this.entryHash).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).url
], DataEntryQuery.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(2).hash
], DataEntryQuery.prototype, "entryHash", void 0);
exports.DataEntryQuery = DataEntryQuery;
class DataEntryQueryResponse {
    constructor(args) {
        this.entryHash =
            args.entryHash == undefined
                ? undefined
                : args.entryHash instanceof Uint8Array
                    ? args.entryHash
                    : buffer_1.Buffer.from(args.entryHash, "hex");
        this.entry = args.entry == undefined ? undefined : protocol.DataEntry.fromObject(args.entry);
        this.txId = args.txId == undefined ? undefined : txid_1.AccumulateTxID.parse(args.txId);
        this.causeTxId = args.causeTxId == undefined ? undefined : txid_1.AccumulateTxID.parse(args.causeTxId);
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new DataEntryQueryResponse(this.asObject());
    }
    asObject() {
        return {
            entryHash: this.entryHash && this.entryHash && buffer_1.Buffer.from(this.entryHash).toString("hex"),
            entry: this.entry && this.entry.asObject(),
            txId: this.txId && this.txId.toString(),
            causeTxId: this.causeTxId && this.causeTxId.toString(),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).hash
], DataEntryQueryResponse.prototype, "entryHash", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], DataEntryQueryResponse.prototype, "entry", void 0);
__decorate([
    encoding_1.encodeAs.field(3).txid
], DataEntryQueryResponse.prototype, "txId", void 0);
__decorate([
    encoding_1.encodeAs.field(4).txid
], DataEntryQueryResponse.prototype, "causeTxId", void 0);
__decorate([
    encoding_1.encodeAs.field(5).time
], DataEntryQueryResponse.prototype, "lastBlockTime", void 0);
exports.DataEntryQueryResponse = DataEntryQueryResponse;
class DataEntrySetQuery {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.start = args.start == undefined ? undefined : args.start;
        this.count = args.count == undefined ? undefined : args.count;
        this.expand = args.expand == undefined ? undefined : args.expand;
        this.height = args.height == undefined ? undefined : args.height;
        this.scratch = args.scratch == undefined ? undefined : args.scratch;
        this.prove = args.prove == undefined ? undefined : args.prove;
        this.includeRemote = args.includeRemote == undefined ? undefined : args.includeRemote;
    }
    copy() {
        return new DataEntrySetQuery(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            start: this.start && this.start,
            count: this.count && this.count,
            expand: this.expand && this.expand,
            height: this.height && this.height,
            scratch: this.scratch && this.scratch,
            prove: this.prove && this.prove,
            includeRemote: this.includeRemote && this.includeRemote,
        };
    }
}
exports.DataEntrySetQuery = DataEntrySetQuery;
class DescriptionResponse {
    constructor(args) {
        this.partitionId = args.partitionId == undefined ? undefined : args.partitionId;
        this.networkType =
            args.networkType == undefined
                ? undefined
                : protocol.PartitionType.fromObject(args.networkType);
        this.network =
            args.network == undefined
                ? undefined
                : args.network instanceof NetworkDescription
                    ? args.network
                    : new NetworkDescription(args.network);
        this.networkAnchor =
            args.networkAnchor == undefined
                ? undefined
                : args.networkAnchor instanceof Uint8Array
                    ? args.networkAnchor
                    : buffer_1.Buffer.from(args.networkAnchor, "hex");
        this.values =
            args.values == undefined
                ? undefined
                : args.values instanceof core.GlobalValues
                    ? args.values
                    : new core.GlobalValues(args.values);
        this.error =
            args.error == undefined
                ? undefined
                : args.error instanceof errors2.Error
                    ? args.error
                    : new errors2.Error(args.error);
    }
    copy() {
        return new DescriptionResponse(this.asObject());
    }
    asObject() {
        return {
            partitionId: this.partitionId && this.partitionId,
            networkType: this.networkType && protocol.PartitionType.getName(this.networkType),
            network: this.network && this.network.asObject(),
            networkAnchor: this.networkAnchor && this.networkAnchor && buffer_1.Buffer.from(this.networkAnchor).toString("hex"),
            values: this.values && this.values.asObject(),
            error: this.error && this.error.asObject(),
        };
    }
}
exports.DescriptionResponse = DescriptionResponse;
class DirectoryQuery {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.start = args.start == undefined ? undefined : args.start;
        this.count = args.count == undefined ? undefined : args.count;
        this.expand = args.expand == undefined ? undefined : args.expand;
        this.height = args.height == undefined ? undefined : args.height;
        this.scratch = args.scratch == undefined ? undefined : args.scratch;
        this.prove = args.prove == undefined ? undefined : args.prove;
        this.includeRemote = args.includeRemote == undefined ? undefined : args.includeRemote;
    }
    copy() {
        return new DirectoryQuery(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            start: this.start && this.start,
            count: this.count && this.count,
            expand: this.expand && this.expand,
            height: this.height && this.height,
            scratch: this.scratch && this.scratch,
            prove: this.prove && this.prove,
            includeRemote: this.includeRemote && this.includeRemote,
        };
    }
}
exports.DirectoryQuery = DirectoryQuery;
class ExecuteRequest {
    constructor(args) {
        this.envelope =
            args.envelope == undefined
                ? undefined
                : args.envelope instanceof messaging.Envelope
                    ? args.envelope
                    : new messaging.Envelope(args.envelope);
        this.checkOnly = args.checkOnly == undefined ? undefined : args.checkOnly;
    }
    copy() {
        return new ExecuteRequest(this.asObject());
    }
    asObject() {
        return {
            envelope: this.envelope && this.envelope.asObject(),
            checkOnly: this.checkOnly && this.checkOnly,
        };
    }
}
exports.ExecuteRequest = ExecuteRequest;
class GeneralQuery {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.expand = args.expand == undefined ? undefined : args.expand;
        this.height = args.height == undefined ? undefined : args.height;
        this.scratch = args.scratch == undefined ? undefined : args.scratch;
        this.prove = args.prove == undefined ? undefined : args.prove;
        this.includeRemote = args.includeRemote == undefined ? undefined : args.includeRemote;
    }
    copy() {
        return new GeneralQuery(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            expand: this.expand && this.expand,
            height: this.height && this.height,
            scratch: this.scratch && this.scratch,
            prove: this.prove && this.prove,
            includeRemote: this.includeRemote && this.includeRemote,
        };
    }
}
exports.GeneralQuery = GeneralQuery;
class GeneralReceipt {
    constructor(args) {
        this.localBlock = args.localBlock == undefined ? undefined : args.localBlock;
        this.localBlockTime =
            args.localBlockTime == undefined
                ? undefined
                : args.localBlockTime instanceof Date
                    ? args.localBlockTime
                    : new Date(args.localBlockTime);
        this.directoryBlock = args.directoryBlock == undefined ? undefined : args.directoryBlock;
        this.majorBlock = args.majorBlock == undefined ? undefined : args.majorBlock;
        this.proof =
            args.proof == undefined
                ? undefined
                : args.proof instanceof merkle.Receipt
                    ? args.proof
                    : new merkle.Receipt(args.proof);
        this.error = args.error == undefined ? undefined : args.error;
    }
    copy() {
        return new GeneralReceipt(this.asObject());
    }
    asObject() {
        return {
            localBlock: this.localBlock && this.localBlock,
            localBlockTime: this.localBlockTime && this.localBlockTime,
            directoryBlock: this.directoryBlock && this.directoryBlock,
            majorBlock: this.majorBlock && this.majorBlock,
            proof: this.proof && this.proof.asObject(),
            error: this.error && this.error,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).uint
], GeneralReceipt.prototype, "localBlock", void 0);
__decorate([
    encoding_1.encodeAs.field(2).time
], GeneralReceipt.prototype, "localBlockTime", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], GeneralReceipt.prototype, "directoryBlock", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], GeneralReceipt.prototype, "majorBlock", void 0);
__decorate([
    encoding_1.encodeAs.field(5).reference
], GeneralReceipt.prototype, "proof", void 0);
__decorate([
    encoding_1.encodeAs.field(6).string
], GeneralReceipt.prototype, "error", void 0);
exports.GeneralReceipt = GeneralReceipt;
class KeyPage {
    constructor(args) {
        this.version = args.version == undefined ? undefined : args.version;
    }
    copy() {
        return new KeyPage(this.asObject());
    }
    asObject() {
        return {
            version: this.version && this.version,
        };
    }
}
exports.KeyPage = KeyPage;
class KeyPageIndexQuery {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.key =
            args.key == undefined
                ? undefined
                : args.key instanceof Uint8Array
                    ? args.key
                    : buffer_1.Buffer.from(args.key, "hex");
    }
    copy() {
        return new KeyPageIndexQuery(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            key: this.key && this.key && buffer_1.Buffer.from(this.key).toString("hex"),
        };
    }
}
exports.KeyPageIndexQuery = KeyPageIndexQuery;
class MajorBlocksQuery {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.start = args.start == undefined ? undefined : args.start;
        this.count = args.count == undefined ? undefined : args.count;
    }
    copy() {
        return new MajorBlocksQuery(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            start: this.start && this.start,
            count: this.count && this.count,
        };
    }
}
exports.MajorBlocksQuery = MajorBlocksQuery;
class MajorQueryResponse {
    constructor(args) {
        this.majorBlockIndex = args.majorBlockIndex == undefined ? undefined : args.majorBlockIndex;
        this.majorBlockTime =
            args.majorBlockTime == undefined
                ? undefined
                : args.majorBlockTime instanceof Date
                    ? args.majorBlockTime
                    : new Date(args.majorBlockTime);
        this.minorBlocks =
            args.minorBlocks == undefined
                ? undefined
                : args.minorBlocks.map((v) => v == undefined ? undefined : v instanceof MinorBlock ? v : new MinorBlock(v));
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new MajorQueryResponse(this.asObject());
    }
    asObject() {
        return {
            majorBlockIndex: this.majorBlockIndex && this.majorBlockIndex,
            majorBlockTime: this.majorBlockTime && this.majorBlockTime,
            minorBlocks: this.minorBlocks &&
                this.minorBlocks?.map((v) => (v == undefined ? undefined : v.asObject())),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
exports.MajorQueryResponse = MajorQueryResponse;
class MerkleState {
    constructor(args) {
        this.height = args.height == undefined ? undefined : args.height;
        this.roots =
            args.roots == undefined
                ? undefined
                : args.roots.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
    }
    copy() {
        return new MerkleState(this.asObject());
    }
    asObject() {
        return {
            height: this.height && this.height,
            roots: this.roots &&
                this.roots?.map((v) => (v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex"))),
        };
    }
}
exports.MerkleState = MerkleState;
class MetricsQuery {
    constructor(args) {
        this.metric = args.metric == undefined ? undefined : args.metric;
        this.duration = args.duration == undefined ? undefined : args.duration;
    }
    copy() {
        return new MetricsQuery(this.asObject());
    }
    asObject() {
        return {
            metric: this.metric && this.metric,
            duration: this.duration && this.duration,
        };
    }
}
exports.MetricsQuery = MetricsQuery;
class MetricsResponse {
    constructor(args) {
        this.value = args.value == undefined ? undefined : args.value;
    }
    copy() {
        return new MetricsResponse(this.asObject());
    }
    asObject() {
        return {
            value: this.value && this.value,
        };
    }
}
exports.MetricsResponse = MetricsResponse;
class MinorBlock {
    constructor(args) {
        this.blockIndex = args.blockIndex == undefined ? undefined : args.blockIndex;
        this.blockTime =
            args.blockTime == undefined
                ? undefined
                : args.blockTime instanceof Date
                    ? args.blockTime
                    : new Date(args.blockTime);
    }
    copy() {
        return new MinorBlock(this.asObject());
    }
    asObject() {
        return {
            blockIndex: this.blockIndex && this.blockIndex,
            blockTime: this.blockTime && this.blockTime,
        };
    }
}
exports.MinorBlock = MinorBlock;
class MinorBlocksQuery {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.start = args.start == undefined ? undefined : args.start;
        this.count = args.count == undefined ? undefined : args.count;
        this.txFetchMode =
            args.txFetchMode == undefined ? undefined : _1.TxFetchMode.fromObject(args.txFetchMode);
        this.blockFilterMode =
            args.blockFilterMode == undefined
                ? undefined
                : _1.BlockFilterMode.fromObject(args.blockFilterMode);
    }
    copy() {
        return new MinorBlocksQuery(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            start: this.start && this.start,
            count: this.count && this.count,
            txFetchMode: this.txFetchMode && _1.TxFetchMode.getName(this.txFetchMode),
            blockFilterMode: this.blockFilterMode && _1.BlockFilterMode.getName(this.blockFilterMode),
        };
    }
}
exports.MinorBlocksQuery = MinorBlocksQuery;
class MinorQueryResponse {
    constructor(args) {
        this.blockIndex = args.blockIndex == undefined ? undefined : args.blockIndex;
        this.blockTime =
            args.blockTime == undefined
                ? undefined
                : args.blockTime instanceof Date
                    ? args.blockTime
                    : new Date(args.blockTime);
        this.txCount = args.txCount == undefined ? undefined : args.txCount;
        this.txIds =
            args.txIds == undefined
                ? undefined
                : args.txIds.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
        this.transactions =
            args.transactions == undefined
                ? undefined
                : args.transactions.map((v) => v == undefined
                    ? undefined
                    : v instanceof TransactionQueryResponse
                        ? v
                        : new TransactionQueryResponse(v));
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new MinorQueryResponse(this.asObject());
    }
    asObject() {
        return {
            blockIndex: this.blockIndex && this.blockIndex,
            blockTime: this.blockTime && this.blockTime,
            txCount: this.txCount && this.txCount,
            txIds: this.txIds &&
                this.txIds?.map((v) => (v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex"))),
            transactions: this.transactions &&
                this.transactions?.map((v) => (v == undefined ? undefined : v.asObject())),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
exports.MinorQueryResponse = MinorQueryResponse;
class MultiResponse {
    constructor(args) {
        this.type = args.type == undefined ? undefined : args.type;
        this.items =
            args.items == undefined ? undefined : args.items.map((v) => (v == undefined ? undefined : v));
        this.start = args.start == undefined ? undefined : args.start;
        this.count = args.count == undefined ? undefined : args.count;
        this.total = args.total == undefined ? undefined : args.total;
        this.otherItems =
            args.otherItems == undefined
                ? undefined
                : args.otherItems.map((v) => (v == undefined ? undefined : v));
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new MultiResponse(this.asObject());
    }
    asObject() {
        return {
            type: this.type && this.type,
            items: this.items && this.items?.map((v) => (v == undefined ? undefined : v)),
            start: this.start && this.start,
            count: this.count && this.count,
            total: this.total && this.total,
            otherItems: this.otherItems && this.otherItems?.map((v) => (v == undefined ? undefined : v)),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
exports.MultiResponse = MultiResponse;
class NetworkDescription {
    constructor(args) {
        this.id = args.id == undefined ? undefined : args.id;
        this.partitions =
            args.partitions == undefined
                ? undefined
                : args.partitions.map((v) => v == undefined
                    ? undefined
                    : v instanceof PartitionDescription
                        ? v
                        : new PartitionDescription(v));
    }
    copy() {
        return new NetworkDescription(this.asObject());
    }
    asObject() {
        return {
            id: this.id && this.id,
            partitions: this.partitions && this.partitions?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], NetworkDescription.prototype, "id", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.reference
], NetworkDescription.prototype, "partitions", void 0);
exports.NetworkDescription = NetworkDescription;
class NodeDescription {
    constructor(args) {
        this.address = args.address == undefined ? undefined : args.address;
        this.type = args.type == undefined ? undefined : config.NodeType.fromObject(args.type);
    }
    copy() {
        return new NodeDescription(this.asObject());
    }
    asObject() {
        return {
            address: this.address && this.address,
            type: this.type && config.NodeType.getName(this.type),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], NodeDescription.prototype, "address", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], NodeDescription.prototype, "type", void 0);
exports.NodeDescription = NodeDescription;
class PartitionDescription {
    constructor(args) {
        this.id = args.id == undefined ? undefined : args.id;
        this.type = args.type == undefined ? undefined : protocol.PartitionType.fromObject(args.type);
        this.basePort = args.basePort == undefined ? undefined : args.basePort;
        this.nodes =
            args.nodes == undefined
                ? undefined
                : args.nodes.map((v) => v == undefined ? undefined : v instanceof NodeDescription ? v : new NodeDescription(v));
    }
    copy() {
        return new PartitionDescription(this.asObject());
    }
    asObject() {
        return {
            id: this.id && this.id,
            type: this.type && protocol.PartitionType.getName(this.type),
            basePort: this.basePort && this.basePort,
            nodes: this.nodes && this.nodes?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], PartitionDescription.prototype, "id", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], PartitionDescription.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(3).int
], PartitionDescription.prototype, "basePort", void 0);
__decorate([
    encoding_1.encodeAs.field(4).repeatable.reference
], PartitionDescription.prototype, "nodes", void 0);
exports.PartitionDescription = PartitionDescription;
class QueryOptions {
    constructor(args) {
        this.expand = args.expand == undefined ? undefined : args.expand;
        this.height = args.height == undefined ? undefined : args.height;
        this.scratch = args.scratch == undefined ? undefined : args.scratch;
        this.prove = args.prove == undefined ? undefined : args.prove;
        this.includeRemote = args.includeRemote == undefined ? undefined : args.includeRemote;
    }
    copy() {
        return new QueryOptions(this.asObject());
    }
    asObject() {
        return {
            expand: this.expand && this.expand,
            height: this.height && this.height,
            scratch: this.scratch && this.scratch,
            prove: this.prove && this.prove,
            includeRemote: this.includeRemote && this.includeRemote,
        };
    }
}
exports.QueryOptions = QueryOptions;
class QueryPagination {
    constructor(args) {
        this.start = args.start == undefined ? undefined : args.start;
        this.count = args.count == undefined ? undefined : args.count;
    }
    copy() {
        return new QueryPagination(this.asObject());
    }
    asObject() {
        return {
            start: this.start && this.start,
            count: this.count && this.count,
        };
    }
}
exports.QueryPagination = QueryPagination;
class ResponseDataEntry {
    constructor(args) {
        this.entryHash =
            args.entryHash == undefined
                ? undefined
                : args.entryHash instanceof Uint8Array
                    ? args.entryHash
                    : buffer_1.Buffer.from(args.entryHash, "hex");
        this.entry = args.entry == undefined ? undefined : protocol.DataEntry.fromObject(args.entry);
        this.txId = args.txId == undefined ? undefined : txid_1.AccumulateTxID.parse(args.txId);
        this.causeTxId = args.causeTxId == undefined ? undefined : txid_1.AccumulateTxID.parse(args.causeTxId);
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new ResponseDataEntry(this.asObject());
    }
    asObject() {
        return {
            entryHash: this.entryHash && this.entryHash && buffer_1.Buffer.from(this.entryHash).toString("hex"),
            entry: this.entry && this.entry.asObject(),
            txId: this.txId && this.txId.toString(),
            causeTxId: this.causeTxId && this.causeTxId.toString(),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).hash
], ResponseDataEntry.prototype, "entryHash", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], ResponseDataEntry.prototype, "entry", void 0);
__decorate([
    encoding_1.encodeAs.field(3).txid
], ResponseDataEntry.prototype, "txId", void 0);
__decorate([
    encoding_1.encodeAs.field(4).txid
], ResponseDataEntry.prototype, "causeTxId", void 0);
__decorate([
    encoding_1.encodeAs.field(5).time
], ResponseDataEntry.prototype, "lastBlockTime", void 0);
exports.ResponseDataEntry = ResponseDataEntry;
class ResponseDataEntrySet {
    constructor(args) {
        this.dataEntries =
            args.dataEntries == undefined
                ? undefined
                : args.dataEntries.map((v) => v == undefined
                    ? undefined
                    : v instanceof ResponseDataEntry
                        ? v
                        : new ResponseDataEntry(v));
        this.total = args.total == undefined ? undefined : args.total;
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new ResponseDataEntrySet(this.asObject());
    }
    asObject() {
        return {
            dataEntries: this.dataEntries &&
                this.dataEntries?.map((v) => (v == undefined ? undefined : v.asObject())),
            total: this.total && this.total,
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).repeatable.reference
], ResponseDataEntrySet.prototype, "dataEntries", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], ResponseDataEntrySet.prototype, "total", void 0);
__decorate([
    encoding_1.encodeAs.field(3).time
], ResponseDataEntrySet.prototype, "lastBlockTime", void 0);
exports.ResponseDataEntrySet = ResponseDataEntrySet;
class ResponseKeyPageIndex {
    constructor(args) {
        this.authority = args.authority == undefined ? undefined : url_1.AccumulateURL.parse(args.authority);
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.index = args.index == undefined ? undefined : args.index;
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new ResponseKeyPageIndex(this.asObject());
    }
    asObject() {
        return {
            authority: this.authority && this.authority.toString(),
            signer: this.signer && this.signer.toString(),
            index: this.index && this.index,
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).url
], ResponseKeyPageIndex.prototype, "authority", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], ResponseKeyPageIndex.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(3).keepEmpty.uint
], ResponseKeyPageIndex.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(4).time
], ResponseKeyPageIndex.prototype, "lastBlockTime", void 0);
exports.ResponseKeyPageIndex = ResponseKeyPageIndex;
class SignatureBook {
    constructor(args) {
        this.authority = args.authority == undefined ? undefined : url_1.AccumulateURL.parse(args.authority);
        this.pages =
            args.pages == undefined
                ? undefined
                : args.pages.map((v) => v == undefined ? undefined : v instanceof SignaturePage ? v : new SignaturePage(v));
    }
    copy() {
        return new SignatureBook(this.asObject());
    }
    asObject() {
        return {
            authority: this.authority && this.authority.toString(),
            pages: this.pages && this.pages?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
exports.SignatureBook = SignatureBook;
class SignaturePage {
    constructor(args) {
        this.signer =
            args.signer == undefined
                ? undefined
                : args.signer instanceof SignerMetadata
                    ? args.signer
                    : new SignerMetadata(args.signer);
        this.signatures =
            args.signatures == undefined
                ? undefined
                : args.signatures.map((v) => v == undefined ? undefined : protocol.Signature.fromObject(v));
    }
    copy() {
        return new SignaturePage(this.asObject());
    }
    asObject() {
        return {
            signer: this.signer && this.signer.asObject(),
            signatures: this.signatures && this.signatures?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
exports.SignaturePage = SignaturePage;
class Signer {
    constructor(args) {
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.timestamp = args.timestamp == undefined ? undefined : args.timestamp;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.version = args.version == undefined ? undefined : args.version;
        this.signatureType =
            args.signatureType == undefined
                ? undefined
                : protocol.SignatureType.fromObject(args.signatureType);
        this.useSimpleHash = args.useSimpleHash == undefined ? undefined : args.useSimpleHash;
    }
    copy() {
        return new Signer(this.asObject());
    }
    asObject() {
        return {
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            timestamp: this.timestamp && this.timestamp,
            url: this.url && this.url.toString(),
            version: this.version && this.version,
            signatureType: this.signatureType && protocol.SignatureType.getName(this.signatureType),
            useSimpleHash: this.useSimpleHash && this.useSimpleHash,
        };
    }
}
exports.Signer = Signer;
class SignerMetadata {
    constructor(args) {
        this.type = args.type == undefined ? undefined : protocol.AccountType.fromObject(args.type);
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.acceptThreshold = args.acceptThreshold == undefined ? undefined : args.acceptThreshold;
    }
    copy() {
        return new SignerMetadata(this.asObject());
    }
    asObject() {
        return {
            type: this.type && protocol.AccountType.getName(this.type),
            url: this.url && this.url.toString(),
            acceptThreshold: this.acceptThreshold && this.acceptThreshold,
        };
    }
}
exports.SignerMetadata = SignerMetadata;
class StatusResponse {
    constructor(args) {
        this.ok = args.ok == undefined ? undefined : args.ok;
        this.bvnHeight = args.bvnHeight == undefined ? undefined : args.bvnHeight;
        this.dnHeight = args.dnHeight == undefined ? undefined : args.dnHeight;
        this.bvnTime =
            args.bvnTime == undefined
                ? undefined
                : args.bvnTime instanceof Date
                    ? args.bvnTime
                    : new Date(args.bvnTime);
        this.dnTime =
            args.dnTime == undefined
                ? undefined
                : args.dnTime instanceof Date
                    ? args.dnTime
                    : new Date(args.dnTime);
        this.lastDirectoryAnchorHeight =
            args.lastDirectoryAnchorHeight == undefined ? undefined : args.lastDirectoryAnchorHeight;
        this.bvnRootHash =
            args.bvnRootHash == undefined
                ? undefined
                : args.bvnRootHash instanceof Uint8Array
                    ? args.bvnRootHash
                    : buffer_1.Buffer.from(args.bvnRootHash, "hex");
        this.dnRootHash =
            args.dnRootHash == undefined
                ? undefined
                : args.dnRootHash instanceof Uint8Array
                    ? args.dnRootHash
                    : buffer_1.Buffer.from(args.dnRootHash, "hex");
        this.bvnBptHash =
            args.bvnBptHash == undefined
                ? undefined
                : args.bvnBptHash instanceof Uint8Array
                    ? args.bvnBptHash
                    : buffer_1.Buffer.from(args.bvnBptHash, "hex");
        this.dnBptHash =
            args.dnBptHash == undefined
                ? undefined
                : args.dnBptHash instanceof Uint8Array
                    ? args.dnBptHash
                    : buffer_1.Buffer.from(args.dnBptHash, "hex");
    }
    copy() {
        return new StatusResponse(this.asObject());
    }
    asObject() {
        return {
            ok: this.ok && this.ok,
            bvnHeight: this.bvnHeight && this.bvnHeight,
            dnHeight: this.dnHeight && this.dnHeight,
            bvnTime: this.bvnTime && this.bvnTime,
            dnTime: this.dnTime && this.dnTime,
            lastDirectoryAnchorHeight: this.lastDirectoryAnchorHeight && this.lastDirectoryAnchorHeight,
            bvnRootHash: this.bvnRootHash && this.bvnRootHash && buffer_1.Buffer.from(this.bvnRootHash).toString("hex"),
            dnRootHash: this.dnRootHash && this.dnRootHash && buffer_1.Buffer.from(this.dnRootHash).toString("hex"),
            bvnBptHash: this.bvnBptHash && this.bvnBptHash && buffer_1.Buffer.from(this.bvnBptHash).toString("hex"),
            dnBptHash: this.dnBptHash && this.dnBptHash && buffer_1.Buffer.from(this.dnBptHash).toString("hex"),
        };
    }
}
exports.StatusResponse = StatusResponse;
class SyntheticTransactionRequest {
    constructor(args) {
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.destination = args.destination == undefined ? undefined : url_1.AccumulateURL.parse(args.destination);
        this.sequenceNumber = args.sequenceNumber == undefined ? undefined : args.sequenceNumber;
        this.anchor = args.anchor == undefined ? undefined : args.anchor;
    }
    copy() {
        return new SyntheticTransactionRequest(this.asObject());
    }
    asObject() {
        return {
            source: this.source && this.source.toString(),
            destination: this.destination && this.destination.toString(),
            sequenceNumber: this.sequenceNumber && this.sequenceNumber,
            anchor: this.anchor && this.anchor,
        };
    }
}
exports.SyntheticTransactionRequest = SyntheticTransactionRequest;
class TokenDeposit {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.amount =
            args.amount == undefined
                ? undefined
                : typeof args.amount === "bigint"
                    ? args.amount
                    : BigInt(args.amount);
        this.txid =
            args.txid == undefined
                ? undefined
                : args.txid instanceof Uint8Array
                    ? args.txid
                    : buffer_1.Buffer.from(args.txid, "hex");
    }
    copy() {
        return new TokenDeposit(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            amount: this.amount && this.amount.toString(),
            txid: this.txid && this.txid && buffer_1.Buffer.from(this.txid).toString("hex"),
        };
    }
}
exports.TokenDeposit = TokenDeposit;
class TokenSend {
    constructor(args) {
        this.from = args.from == undefined ? undefined : url_1.AccumulateURL.parse(args.from);
        this.to =
            args.to == undefined
                ? undefined
                : args.to.map((v) => v == undefined ? undefined : v instanceof TokenDeposit ? v : new TokenDeposit(v));
    }
    copy() {
        return new TokenSend(this.asObject());
    }
    asObject() {
        return {
            from: this.from && this.from.toString(),
            to: this.to && this.to?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
exports.TokenSend = TokenSend;
class TransactionQueryResponse {
    constructor(args) {
        this.type = args.type == undefined ? undefined : args.type;
        this.mainChain =
            args.mainChain == undefined
                ? undefined
                : args.mainChain instanceof MerkleState
                    ? args.mainChain
                    : new MerkleState(args.mainChain);
        this.data = args.data == undefined ? undefined : args.data;
        this.origin = args.origin == undefined ? undefined : url_1.AccumulateURL.parse(args.origin);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
        this.txid = args.txid == undefined ? undefined : txid_1.AccumulateTxID.parse(args.txid);
        this.transaction =
            args.transaction == undefined
                ? undefined
                : args.transaction instanceof protocol.Transaction
                    ? args.transaction
                    : new protocol.Transaction(args.transaction);
        this.signatures =
            args.signatures == undefined
                ? undefined
                : args.signatures.map((v) => v == undefined ? undefined : protocol.Signature.fromObject(v));
        this.status =
            args.status == undefined
                ? undefined
                : args.status instanceof protocol.TransactionStatus
                    ? args.status
                    : new protocol.TransactionStatus(args.status);
        this.produced =
            args.produced == undefined
                ? undefined
                : args.produced.map((v) => (v == undefined ? undefined : txid_1.AccumulateTxID.parse(v)));
        this.receipts =
            args.receipts == undefined
                ? undefined
                : args.receipts.map((v) => v == undefined ? undefined : v instanceof TxReceipt ? v : new TxReceipt(v));
        this.signatureBooks =
            args.signatureBooks == undefined
                ? undefined
                : args.signatureBooks.map((v) => v == undefined ? undefined : v instanceof SignatureBook ? v : new SignatureBook(v));
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new TransactionQueryResponse(this.asObject());
    }
    asObject() {
        return {
            type: this.type && this.type,
            mainChain: this.mainChain && this.mainChain.asObject(),
            data: this.data && this.data,
            origin: this.origin && this.origin.toString(),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
            txid: this.txid && this.txid.toString(),
            transaction: this.transaction && this.transaction.asObject(),
            signatures: this.signatures && this.signatures?.map((v) => (v == undefined ? undefined : v.asObject())),
            status: this.status && this.status.asObject(),
            produced: this.produced && this.produced?.map((v) => (v == undefined ? undefined : v.toString())),
            receipts: this.receipts && this.receipts?.map((v) => (v == undefined ? undefined : v.asObject())),
            signatureBooks: this.signatureBooks &&
                this.signatureBooks?.map((v) => (v == undefined ? undefined : v.asObject())),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
exports.TransactionQueryResponse = TransactionQueryResponse;
class TxHistoryQuery {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.start = args.start == undefined ? undefined : args.start;
        this.count = args.count == undefined ? undefined : args.count;
        this.scratch = args.scratch == undefined ? undefined : args.scratch;
    }
    copy() {
        return new TxHistoryQuery(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            start: this.start && this.start,
            count: this.count && this.count,
            scratch: this.scratch && this.scratch,
        };
    }
}
exports.TxHistoryQuery = TxHistoryQuery;
class TxReceipt {
    constructor(args) {
        this.localBlock = args.localBlock == undefined ? undefined : args.localBlock;
        this.localBlockTime =
            args.localBlockTime == undefined
                ? undefined
                : args.localBlockTime instanceof Date
                    ? args.localBlockTime
                    : new Date(args.localBlockTime);
        this.directoryBlock = args.directoryBlock == undefined ? undefined : args.directoryBlock;
        this.majorBlock = args.majorBlock == undefined ? undefined : args.majorBlock;
        this.proof =
            args.proof == undefined
                ? undefined
                : args.proof instanceof merkle.Receipt
                    ? args.proof
                    : new merkle.Receipt(args.proof);
        this.error = args.error == undefined ? undefined : args.error;
        this.account = args.account == undefined ? undefined : url_1.AccumulateURL.parse(args.account);
        this.chain = args.chain == undefined ? undefined : args.chain;
    }
    copy() {
        return new TxReceipt(this.asObject());
    }
    asObject() {
        return {
            localBlock: this.localBlock && this.localBlock,
            localBlockTime: this.localBlockTime && this.localBlockTime,
            directoryBlock: this.directoryBlock && this.directoryBlock,
            majorBlock: this.majorBlock && this.majorBlock,
            proof: this.proof && this.proof.asObject(),
            error: this.error && this.error,
            account: this.account && this.account.toString(),
            chain: this.chain && this.chain,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1, 1).uint
], TxReceipt.prototype, "localBlock", void 0);
__decorate([
    encoding_1.encodeAs.field(1, 2).time
], TxReceipt.prototype, "localBlockTime", void 0);
__decorate([
    encoding_1.encodeAs.field(1, 3).uint
], TxReceipt.prototype, "directoryBlock", void 0);
__decorate([
    encoding_1.encodeAs.field(1, 4).uint
], TxReceipt.prototype, "majorBlock", void 0);
__decorate([
    encoding_1.encodeAs.field(1, 5).reference
], TxReceipt.prototype, "proof", void 0);
__decorate([
    encoding_1.encodeAs.field(1, 6).string
], TxReceipt.prototype, "error", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], TxReceipt.prototype, "account", void 0);
__decorate([
    encoding_1.encodeAs.field(3).string
], TxReceipt.prototype, "chain", void 0);
exports.TxReceipt = TxReceipt;
class TxRequest {
    constructor(args) {
        this.checkOnly = args.checkOnly == undefined ? undefined : args.checkOnly;
        this.isEnvelope = args.isEnvelope == undefined ? undefined : args.isEnvelope;
        this.origin = args.origin == undefined ? undefined : url_1.AccumulateURL.parse(args.origin);
        this.signer =
            args.signer == undefined
                ? undefined
                : args.signer instanceof Signer
                    ? args.signer
                    : new Signer(args.signer);
        this.signature =
            args.signature == undefined
                ? undefined
                : args.signature instanceof Uint8Array
                    ? args.signature
                    : buffer_1.Buffer.from(args.signature, "hex");
        this.keyPage =
            args.keyPage == undefined
                ? undefined
                : args.keyPage instanceof KeyPage
                    ? args.keyPage
                    : new KeyPage(args.keyPage);
        this.txHash =
            args.txHash == undefined
                ? undefined
                : args.txHash instanceof Uint8Array
                    ? args.txHash
                    : buffer_1.Buffer.from(args.txHash, "hex");
        this.payload = args.payload == undefined ? undefined : args.payload;
        this.memo = args.memo == undefined ? undefined : args.memo;
        this.metadata =
            args.metadata == undefined
                ? undefined
                : args.metadata instanceof Uint8Array
                    ? args.metadata
                    : buffer_1.Buffer.from(args.metadata, "hex");
    }
    copy() {
        return new TxRequest(this.asObject());
    }
    asObject() {
        return {
            checkOnly: this.checkOnly && this.checkOnly,
            isEnvelope: this.isEnvelope && this.isEnvelope,
            origin: this.origin && this.origin.toString(),
            signer: this.signer && this.signer.asObject(),
            signature: this.signature && this.signature && buffer_1.Buffer.from(this.signature).toString("hex"),
            keyPage: this.keyPage && this.keyPage.asObject(),
            txHash: this.txHash && this.txHash && buffer_1.Buffer.from(this.txHash).toString("hex"),
            payload: this.payload && this.payload,
            memo: this.memo && this.memo,
            metadata: this.metadata && this.metadata && buffer_1.Buffer.from(this.metadata).toString("hex"),
        };
    }
}
exports.TxRequest = TxRequest;
class TxResponse {
    constructor(args) {
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
        this.txid = args.txid == undefined ? undefined : txid_1.AccumulateTxID.parse(args.txid);
        this.signatureHashes =
            args.signatureHashes == undefined
                ? undefined
                : args.signatureHashes.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
        this.simpleHash =
            args.simpleHash == undefined
                ? undefined
                : args.simpleHash instanceof Uint8Array
                    ? args.simpleHash
                    : buffer_1.Buffer.from(args.simpleHash, "hex");
        this.code = args.code == undefined ? undefined : args.code;
        this.message = args.message == undefined ? undefined : args.message;
        this.delivered = args.delivered == undefined ? undefined : args.delivered;
        this.result = args.result == undefined ? undefined : args.result;
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new TxResponse(this.asObject());
    }
    asObject() {
        return {
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
            txid: this.txid && this.txid.toString(),
            signatureHashes: this.signatureHashes &&
                this.signatureHashes?.map((v) => v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex")),
            simpleHash: this.simpleHash && this.simpleHash && buffer_1.Buffer.from(this.simpleHash).toString("hex"),
            code: this.code && this.code,
            message: this.message && this.message,
            delivered: this.delivered && this.delivered,
            result: this.result && this.result,
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
exports.TxResponse = TxResponse;
class TxnQuery {
    constructor(args) {
        this.expand = args.expand == undefined ? undefined : args.expand;
        this.height = args.height == undefined ? undefined : args.height;
        this.scratch = args.scratch == undefined ? undefined : args.scratch;
        this.prove = args.prove == undefined ? undefined : args.prove;
        this.includeRemote = args.includeRemote == undefined ? undefined : args.includeRemote;
        this.txid =
            args.txid == undefined
                ? undefined
                : args.txid instanceof Uint8Array
                    ? args.txid
                    : buffer_1.Buffer.from(args.txid, "hex");
        this.txIdUrl = args.txIdUrl == undefined ? undefined : txid_1.AccumulateTxID.parse(args.txIdUrl);
        this.wait = args.wait == undefined ? undefined : args.wait;
        this.ignorePending = args.ignorePending == undefined ? undefined : args.ignorePending;
    }
    copy() {
        return new TxnQuery(this.asObject());
    }
    asObject() {
        return {
            expand: this.expand && this.expand,
            height: this.height && this.height,
            scratch: this.scratch && this.scratch,
            prove: this.prove && this.prove,
            includeRemote: this.includeRemote && this.includeRemote,
            txid: this.txid && this.txid && buffer_1.Buffer.from(this.txid).toString("hex"),
            txIdUrl: this.txIdUrl && this.txIdUrl.toString(),
            wait: this.wait && this.wait,
            ignorePending: this.ignorePending && this.ignorePending,
        };
    }
}
exports.TxnQuery = TxnQuery;
class UrlQuery {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
    }
    copy() {
        return new UrlQuery(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
        };
    }
}
exports.UrlQuery = UrlQuery;
class VersionResponse {
    constructor(args) {
        this.version = args.version == undefined ? undefined : args.version;
        this.commit = args.commit == undefined ? undefined : args.commit;
        this.versionIsKnown = args.versionIsKnown == undefined ? undefined : args.versionIsKnown;
        this.isTestNet = args.isTestNet == undefined ? undefined : args.isTestNet;
    }
    copy() {
        return new VersionResponse(this.asObject());
    }
    asObject() {
        return {
            version: this.version && this.version,
            commit: this.commit && this.commit,
            versionIsKnown: this.versionIsKnown && this.versionIsKnown,
            isTestNet: this.isTestNet && this.isTestNet,
        };
    }
}
exports.VersionResponse = VersionResponse;
//# sourceMappingURL=types_gen.js.map